export const YYYY_MM_DD_FORMAT = "YYYY-MM-DD";
export const YYYY_MM_DD_HH_MM_FORMAT = "YYYY-MM-DD hh:mm";
export const MMM_DD_FORMAT = "MMM DD";
export const DDDD_MMMM_YYYY_HH_MM_FORMAT = "dddd DD MMMM yyyy hh:mm";
export const DDDD_MMMM_YYYY_FORMAT = "dddd DD MMMM yyyy";
export const HH_MM_FORMAT = "hh:mm";
export const OTP_MAX_SIZE = 6;
export const PIN_MAX_SIZE = 6;
export const PHONE_NUMBER_MAX_SIZE = 10;
export const FILE_MAX_SIZE = 10; // Mo
export const FILE_MAX_SIZE_STR = "10Mo";
export const APP_NAME = "IClickIPay";
export const YYYY_MM_DD_HH_MM_SS_FORMAT = "YYYY-MM-DD hh:mm:ss";
export const DD_MM_YYYY_FORMAT = "DD MMMM yyyy";
export const GEO_ADDRESS_REGEX = "^[-]?(([0-8]?[0-9])\\.(\\d+))|(90(\\.0+)?)$";
